import { useContext } from "react";
import { Box, Autocomplete, Checkbox, Chip, TextField, FormControlLabel } from "@mui/material";
import { BulkContext, countryGroups } from '../store/bulklist-filters-context';
import { removeDuplicateCountries } from '../utils/global';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export default function SearchCountry() {
    const { comparingCountries, setComparingCountries, countries } = useContext(BulkContext);

    // handleSelectAll removed; bulk selection now via manual group selection
    console.log("comparingCountries", comparingCountries);


    return (
        <>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1, mb: 1.5 }}>
              <Autocomplete
                options={countryGroups}
                getOptionLabel={(option) => option.label}
                onChange={(event, value) => {
                  if (value?.label === "World") {
                    setComparingCountries(removeDuplicateCountries(countries));
                  } else {
                    // TODO: implement group-specific filtering
                    setComparingCountries([]);
                  }
                }}
                renderInput={(params) => (
                  <TextField {...params} placeholder="Select group..." />
                )}
              />

                <Autocomplete
                    multiple
                    id="countries"
                    value={comparingCountries}
                    options={countries.filter((country, index, self) =>
                        index === self.findIndex(c => c.id === country.id)
                    )}
                    popupIcon={<ExpandMoreIcon />}
                    disableCloseOnSelect
                    disableClearable
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    onChange={(event, value, reason, details) => {
                        setComparingCountries(removeDuplicateCountries(value));
                    }}
                    getOptionLabel={(option) => option.label}
                    renderTags={(value, getTagProps) => {
                        // MUI's limitTags only applies while the field is unfocused; once
                        // opened it renders every selected chip, which is unusable for a
                        // "World" selection (200+ countries). Always collapse to a single
                        // summary chip past a small threshold, regardless of focus state.
                        const SUMMARY_THRESHOLD = 5;
                        if (value.length > SUMMARY_THRESHOLD) {
                            return [
                                <Chip
                                    key="countries-summary"
                                    size="small"
                                    label={`${value.length} countries/regions selected`}
                                />
                            ];
                        }
                        return value.map((option, index) => {
                            const { key, ...tagProps } = getTagProps({ index });
                            return <Chip key={option.id} label={option.label} {...tagProps} />;
                        });
                    }}
                    renderOption={(props, option, { selected }) => {
                        const { key, ...optionProps } = props;
                        return (
                            <li key={key} {...optionProps}>
                                <Checkbox
                                    icon={icon}
                                    checkedIcon={checkedIcon}
                                    style={{ marginRight: 8 }}
                                    checked={selected}
                                />
                                {option.label}
                            </li>
                        );
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            placeholder="Search country/region..."
                            inputProps={{
                                ...params.inputProps,
                                autoComplete: "off",
                                autoCorrect: "off",
                                autoCapitalize: "off",
                                spellCheck: "false",
                            }}
                            sx={(theme) => ({
                                "& .MuiInputBase-input::placeholder": {
                                    fontSize: "11px",
                                    color: theme.palette.primary.fontColor,
                                    opacity: "0.7",
                                },
                                "@media (min-width: 1200px)": {
                                    "& .MuiInputBase-input::placeholder": {
                                        fontSize: "12px",
                                    },
                                },
                                "@media (min-width: 1366px)": {
                                    "& .MuiInputBase-input::placeholder": {
                                        fontSize: "13px",
                                    },
                                },
                            })}
                        />
                    )}
                />
            </Box>
        </>
    );
}